<mat-sidenav-container hasBackdrop="false" id="sidenav-container">
    <mat-sidenav id="sidenav" #sidenav>
        <app-menu></app-menu>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
